/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import {
  arrayOf, bool, func, instanceOf, number, oneOf, shape, string
} from 'prop-types';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
// eslint-disable-next-line import/no-cycle
import Content from '../Content/Content.component';
import { EtchPlaceholder } from '../Placeholder/EtchPlaceholder';

class Etch extends Component {

  getEtchContent = () => {
    const props = {
      ...this.props
    };
    const {
      channel,
      contentType,
      deliveryZip,
      dimensions,
      disableSwipeNavigation,
      dpdResponse,
      env,
      favorites,
      isCategory,
      keyword,
      linkType,
      navParam,
      onFavoriteChange,
      onVisNavRender,
      parentNavParam,
      partialTemplates,
      relatedResults,
      showArrows,
      showDpdPod,
      sku,
      storeId,
      templates,
      visualNavPromos,
      showFavoritesCount
    } = props;
    let etchContent = null;
    const { exclude, include } = this.props;
    if (templates.length) {
      etchContent = templates.reduce((acc, template, templateIndex) => {
        return [
          ...acc,
          ...template.Content.map((content, contentIndex) => (
            <Content
              channel={channel}
              contentType={contentType}
              deliveryZip={deliveryZip}
              dimensions={dimensions}
              disableSwipeNavigation={disableSwipeNavigation}
              dpdResponse={dpdResponse}
              env={env}
              exclude={exclude}
              favorites={favorites}
              include={include}
              isCategory={isCategory}
              key={`etch--${templateIndex}-${content.id}-${contentIndex}`}
              keyword={keyword}
              linkType={linkType}
              navParam={navParam}
              onFavoriteChange={onFavoriteChange}
              onVisNavRender={onVisNavRender}
              opts={content}
              parentNavParam={parentNavParam}
              partialTemplates={partialTemplates}
              showArrows={showArrows}
              sku={sku}
              storeId={storeId}
              visualNavPromos={visualNavPromos}
              visualNavResults={relatedResults}
              showFavoritesCount={showFavoritesCount}
              showDpdPod={showDpdPod}
            />
          ))
        ];
      }, []);
    }
    return etchContent;
  };

  render() {
    const {
      templates = []
    } = this.props;

    const content = this.getEtchContent({ ...this.props });
    // Need to have templates or template path to render
    if (!(templates.length)) {
      return null;
    }
    return (
      <LoadingPlaceholder
        customPlaceholder={EtchPlaceholder()}
        ready
      >
        {content}
      </LoadingPlaceholder>
    );
  }
}

Etch.propTypes = {
  channel: oneOf([
    'desktop',
    'mobile'
  ]),
  contentType: string,
  deliveryZip: string,
  dimensions: instanceOf(Array),
  /** Exclude content of these types */
  exclude: arrayOf(string),
  favorites: arrayOf(number),
  /** Include only content of these types */
  include: arrayOf(string),
  isCategory: bool,
  linkType: string,
  onFavoriteChange: func,
  onVisNavRender: func,
  parentNavParam: string,
  partialTemplates: instanceOf(Array),
  storeId: string,
  /** Path to etch json file */
  templatePath: string,
  /** Array of etch content definitions */
  templates: instanceOf(Array),
  showArrows: bool,
  disableSwipeNavigation: bool,
  showFavoritesCount: bool
};

Etch.defaultProps = {
  channel: 'desktop',
  contentType: 'categorypage',
  deliveryZip: null,
  showArrows: true,
  disableSwipeNavigation: false,
  dimensions: [],
  exclude: [],
  favorites: [],
  include: [],
  isCategory: true,
  linkType: null,
  onFavoriteChange: null,
  onVisNavRender: () => {},
  parentNavParam: '',
  partialTemplates: [],
  storeId: '121',
  templatePath: null,
  templates: [],
  showFavoritesCount: false
};

export default Etch;
